// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"365":"cb355538","648":"737a5600","970":"019d026b"}[chunkId] || chunkId) + "." + {"365":"5d558c5ef046910b","648":"829db79876cc691d","661":"d26efdd479b4ecc2","777":"cf24280d22977743","970":"bb49767131f31b99"}[chunkId] + ".js";
};